export const GET_WORK_SOURCES = 'GET_WORK_SOURCES'
export const GET_SALARY_SOURCES = 'GET_SALARY_SOURCES'
export const setNavbarChatNotifs = 'setNavbarChatNotifs'
export const SET_THEME = 'SET_THEME'
export const TOGGLE_THEME = 'TOGGLE_THEME'